/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
    selector: 'big-ui-result-filter-label',
    templateUrl: './result-filter-label.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'inline-block',
    },
})
export class ResultFilterLabelComponent {

    /**
     * The variant of the label. Dark is used in the search component. Light is used in subject areas (Themenbereiche).
     */
    public readonly variant = input<'dark' | 'light'>('light');
    public readonly isActive = input<boolean>(false);
    public readonly ariaLabel = input<string>();

    public readonly labelClasses = computed(() => {
        const variant = this.variant();
        const isActive = this.isActive();

        const defaultClasses = {
            'focus-visible:inset-ring-0': true,
            'focus-visible:ring-4': true,
            'outline-0': true,
            'px-2': true,
            'py-1': true,
            'rounded-sm': true,
            'text-left': true,
            block: true,
        };

        if (variant === 'dark') {
            return {
                ...defaultClasses,
                'focus-visible:ring-primary-200': isActive,
                'bg-white': isActive,
                'text-body': isActive,
                'bg-primary-700': !isActive,
                'dark:bg-primary-200': !isActive,
                'dark:focus-visible:ring-white': !isActive,
                'dark:text-body': !isActive,
                'hover:bg-white': !isActive,
                'hover:text-body': !isActive,
                'text-white': !isActive,
            };
        }

        // Light variant
        return {
            ...defaultClasses,
            'dark:focus-visible:ring-white': true,
            'bg-primary-500': isActive,
            'text-white': isActive,
            'dark:bg-primary-400': isActive,
            'bg-white': !isActive,
            'focus-visible:ring-primary-800': !isActive,
            'hover:text-white': !isActive,
            'hover:bg-primary-500': !isActive,
            'dark:bg-primary-500': !isActive,
            'dark:hover:bg-primary-400': !isActive,
            'dark:hover:text-white': !isActive,
            'dark:text-primary-50': !isActive,
        };
    });

    public readonly buttonClick = output();
}
